var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_336_1247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_336_1247",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_336_1247",
    transform: "scale(0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_336_1247",
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKOSURBVHgBpVRLaxNRFP7uTTLp5NFiX1qoxYrd1OLKlWjVVgrVKuLOhYrVtqIoVvEPuHCv4AMiGMS1KJTWKq4EwRCVtO6laE3TpG6qZjKTe69nbiZjYutCeuDeuTmP7zy+Q9iXrp43APYyupgCuPvVRyGgX4Ckt9Qa9w0oUvtv7YFUkH7sYV4wPEP1LT03z/mfQvbd/C+F/9UZFd2NjUA8DiWlr18PPFhrYMwNJmXLJsQuTcA8OgLe0qyNIp9HcWoaqw8SECvf1wCyz109gldGoy9jVx9akwmwaAzF6Rk4c/MaPdTXC3PkMJRlIX9uAqUPGb9COlIDUSHcnUugvQ0dL6cglnJYIWfx9VulzGrWzW1oTdxHsHsbssPH4Lh2D4ijZh5Nk5fBwmEsnx2Ds5jVrETHRxG7OA5BXuVcnqq5QGk5mm5co0DlV8X9oQU4IkeG8ePpc4hsrtI7gTZNXkHjVUoQiWidky+QzzNEhw6R3dAMRwiQR6l/d+LB9nZwYqiUyehK3CNsG0unR5GjI37+8gdbmv+kgWMUE3fn58YHyGC6iCWboiUM04ShqkNUiJ84TtmikG9TRIbSLUTMiPYNWCWdsEqUFlko0HAXYQ4cRJicGgjcFBLh7d0wtnaSTujMAdIbgwcgiRCZW/aJ+LOQjMNKPkZofz+MoQF/S1go5HFaEWNoEKH+fdq3ltG6zbaST+Ck04jdvYOGUyd1f6poQdmOHoKri927DeddCsWHydrQeiCUBVbPnIf9YhYmMQWqRiwsILizF81z7xG9dRP2q9fkM0b0letCWaFzh1gDqLztoHZ5xxaYE6NQlMSemUU5/bGupeqI1wf6f9GbbWHjYgeVYtfpL2sMGxDJ1KPf5owWPqZudi0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovative);
export default __webpack_public_path__ + "static/media/innovative.45f52a054efbc6b672b76dd430bab0b2.svg";
export { ForwardRef as ReactComponent };